import moment from 'moment-timezone';
import { LONG_DATE_TIME_FORMAT_24, shownByRadioComplete, shownByRadioNoload } from './Constants';

export function isAllEmpty(inputs) {
    return inputs.every(input => !input.value);
}

export function isBlank(inputs) {
    return inputs.some(input => input.dbSaved && input.canBeSaved && !input.value);
}

export function isNoLoadDefault(inputs) {
    //checks if the noshoweventtime has data saved from the DB
    return inputs.some(input => input.name === "noShowEventTime" && input.dbSaved)
}

export function isOnBoardOrCompleteDBSaved(inputs) {
    return inputs.some(input => (input.name === 'pickupEventTime' && input.dbSaved)
        || (input.name === 'dropoffEventTime' && input.dbSaved));
}

export function formateDateTimeLabels(dateTime) {
    return moment(dateTime).format(LONG_DATE_TIME_FORMAT_24);
}

export function getSelectedRadio(inputs) {
    //Definition states that if noload has data, default radio is noload
    return isNoLoadDefault(inputs) ? 'noload' : 'complete';
}

export function setDisabledRadio(selectedRadio, inputs) {
    //definition states that if noload has data, complete is disabled -> (if it's default radio)
    // and if onboard or complete has data, noload is disabled
    let disabledRadio = 'none';
    if (selectedRadio === 'noload') {
        disabledRadio = 'complete';
    } else if (isOnBoardOrCompleteDBSaved(inputs)) {
        disabledRadio = 'noload';
    }
    return disabledRadio
}

export function shouldBeShownByRadio(inputName, selectedRadio) {
    //checks if the input should be there based on selected radio, saved in the DB and if it can be saved
    return selectedRadio === 'complete' ? shownByRadioComplete.includes(inputName)
        : shownByRadioNoload.includes(inputName);
}

export function mergeFormatTZ(currentTime, inputDate, timeZone) {
    const hour = parseInt(currentTime.substring(0, 2), 10);
    const minutes = parseInt(currentTime.substring(5, 3), 10);
    const selectedDateTime = moment.tz(inputDate, timeZone);
    selectedDateTime.set({ 'hour': hour, 'minute': minutes });
    return selectedDateTime;
}

export function formatForCalendar(value, timeZone) {
    return new Date(value.utcOffset(timeZone).format('YYYY-MM-DD HH:mm'));
}
